$(document).ready(function () {
    $("#preloader").fadeOut(700);
});